import angular from 'angular';
import financialStatusWidgetContentModule from './components/financial-status-widget-content-module';
import FinancialStatusWidgetComponent from './financial-status-widget-component';

export default angular
  .module('financial-status-widget', [financialStatusWidgetContentModule.name, 'rw-retailer-info', 'rw-multistore-selector'])
  .component('financialStatusWidget', new FinancialStatusWidgetComponent());



// WEBPACK FOOTER //
// ./src/modules/dashboard/components/dashboard-widget/financial-status/financial-status-widget-module.js